import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import Policies from "../../components/Settings/Policies";
import TermsConditions from "../../components/Settings/TermsConditions";
import Statement from "../../components/Settings/Statement";
import About from "../../components/Settings/About";
import Contactus from "../../components/Settings/Contactus";
import CmsList from "../../components/Settings/CmsList";
import ChangePassword from "../../components/Settings/ChangePassword";
import SocialMedia from "../../components/Settings/SocialMedia";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import ColorManagement from "../../components/Settings/ColorManagement";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { selectAuthGate } from "../../redux/selectors/authSelector";

// const Settings_Main = () => {
//     const [activeTab, setActiveTab] = useState("Social Media Link");
//     const location = useLocation();
//     const tabs = ["Social Media Link", "Policies", "Contact Us", "About Us", "Change Password", "Color Management"];
//     // const navigate = useNavigate();
//     const navigate = useCountryNavigate();

//     const handleAddButtonClick = () => {
//         if (activeTab === "Statements") {
//             navigate("education/performance/add");
//         } else if (activeTab === "Contact Us") {
//             navigate("education/subject/add");
//         } else if (activeTab === "About Us") {
//             navigate("education/facilities/add");
//         } else if (activeTab === "Change Password") {
//             navigate("education/streams/add");
//         }
//     };

//     const getAddButtonLabel = () => {
//         switch (activeTab) {
//             case "Statements":
//                 return "+ Add Statements";
//             case "Contact Us":
//                 return "+ Add Subject";
//             case "About Us":
//                 return "+ Add Facility";
//             case "Change Password":
//                 return "+ Add Change Password";
//             default:
//                 return null;
//         }
//     };

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };
//     useEffect(() => {

//         if (location.state?.currentTab) {
//             console.log("location.state?.currentTab", location.state?.currentTab)
//             setActiveTab(location.state.currentTab);
//         }
//     }, [location.state?.currentTab]);

//     return (
//         <>
//             <Title name="Settings" />
//             <Topbar title="Settings & More" />
//             <div className="p-6 space-y-6 pr-0">
//                 {/* Tabs */}
//                 <div className="flex justify-between flex-wrap gap-y-2">
//                     <div className="flex gap-2 overflow-x-auto">
//                         {tabs?.map((tab) => (
//                             <button
//                                 key={tab}
//                                 className={`px-3 py-2 rounded-lg whitespace-nowrap ${activeTab === tab
//                                     ? "bg-secondary_main text-white"
//                                     : "bg-white text-black"
//                                     }`}
//                                 onClick={() => handleTabClick(tab)}
//                             >
//                                 {tab}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Conditional Tab Content */}
//                 {activeTab === "Social Media Link" && (
//                     <>
//                         <SocialMedia />
//                     </>
//                 )}

//                 {activeTab === "Policies" && (
//                     <>
//                         {/* <Policies/>
//                         <TermsConditions/> */}
//                         <CmsList />
//                     </>
//                 )}

//                 {/* {activeTab === "Statements"  && (
//                     <>
//                         <Statement />
//                     </>
//                 )} */}

//                 {activeTab === "Contact Us" && (
//                     <>
//                         <Contactus />
//                     </>
//                 )}

//                 {activeTab === "About Us" && (
//                     <>
//                         <About />
//                     </>
//                 )}

//                 {activeTab === "Change Password" && (
//                     <>
//                         <ChangePassword />
//                     </>
//                 )}

//                 {activeTab === "Color Management" && (
//                     <>
//                         <ColorManagement />
//                     </>
//                 )}

//             </div>
//         </>
//     )
// }

const Settings_Main = () => {
  const location = useLocation();
  const navigate = useCountryNavigate();
  const { school } = useSelector(selectAuthGate);
  const [activeTab, setActiveTab] = useState("Social Media Link");
  const [showColorManagement, setShowColorManagement] = useState(false);
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    setShowColorManagement(school?.color_managenment === 1);
  }, [school]);
  /* -------------------- HANDLE LOCATION TAB -------------------- */
  useEffect(() => {
    if (location.state?.currentTab) {
      setActiveTab(location.state.currentTab);
    }
  }, [location.state?.currentTab]);

  /* -------------------- SAFETY: RESET TAB -------------------- */
  useEffect(() => {
    if (!showColorManagement && activeTab === "Color Management") {
      setActiveTab("Social Media Link");
    }
  }, [showColorManagement, activeTab]);

  /* -------------------- TABS -------------------- */
  const baseTabs = [
    "Social Media Link",
    "Policies",
    "Contact Us",
    "About Us",
    "Change Password",
  ];

  const tabs = showColorManagement
    ? [...baseTabs, "Color Management"]
    : baseTabs;

  return (
    <>
      <Title name="Settings" />
      <Topbar title="Settings & More" />

      <div className="p-6 space-y-6 pr-0">
        {/* Tabs */}
        <div className="flex justify-between flex-wrap gap-y-2">
          <div className="flex gap-2 overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`px-3 py-2 rounded-lg whitespace-nowrap ${
                  activeTab === tab
                    ? "bg-secondary_main text-white"
                    : "bg-white text-black"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === "Social Media Link" && <SocialMedia />}

        {activeTab === "Policies" && <CmsList />}

        {activeTab === "Contact Us" && <Contactus />}

        {activeTab === "About Us" && <About />}

        {activeTab === "Change Password" && <ChangePassword />}

        {activeTab === "Color Management" && showColorManagement && (
          <ColorManagement />
        )}
      </div>
    </>
  );
};

export default Settings_Main;
